/**
 * @generated SignedSource<<1431cbe11f87c4b06ae34b6a90f00d7e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhaseEditor_project$data = {
  readonly id: number;
  readonly no_phase_revenue_budget: number | null | undefined;
  readonly phases: ReadonlyArray<{
    readonly color: string;
    readonly id: number;
    readonly name: string;
    readonly revenue_budget: number | null | undefined;
    readonly start_date: string | null | undefined;
  }>;
  readonly " $fragmentType": "PhaseEditor_project";
};
export type PhaseEditor_project$key = {
  readonly " $data"?: PhaseEditor_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhaseEditor_project">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PhaseEditor_project",
  "selections": [
    (v0/*: any*/),
    {
      "alias": "no_phase_revenue_budget",
      "args": null,
      "kind": "ScalarField",
      "name": "no_phase_revenue_budget_private",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "phases",
      "kind": "LinkedField",
      "name": "phases",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        },
        {
          "alias": "start_date",
          "args": null,
          "kind": "ScalarField",
          "name": "start_date_runn",
          "storageKey": null
        },
        {
          "alias": "revenue_budget",
          "args": null,
          "kind": "ScalarField",
          "name": "revenue_budget_private",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "projects",
  "abstractKey": null
};
})();

(node as any).hash = "9fc55f8304b93393a88d42422325e3ee";

export default node;
